function safeNumber(n: number): boolean {
  return Number.MIN_SAFE_INTEGER <= n && n <= Number.MAX_SAFE_INTEGER;
}

export default safeNumber;
